// eslint-disable-next-line no-unused-vars
import React from 'react';
import {Carousel} from 'react-bootstrap';
import styled from 'styled-components';
import {slides} from '../../../utils/gameData';

const StyledCarousel = styled(Carousel).attrs({className: 'mb-3 d-none d-lg-block'})`
  .carousel-indicators [data-bs-target] {
    width: 11px !important;
    height: 11px !important;
    background-image: url('/assets/slider/pointer.png') !important;
    background-repeat: no-repeat !important;
    background-size: contain !important;
    opacity: 0.5;
    transition: opacity 0.6s ease;
  }

  .carousel-indicators {
    right: unset !important;
    margin-right: unset !important;
    margin-bottom: 5rem !important;
    margin-left: 5% !important;
    left: 0px !important;
    bottom: unset !important;
    top: 14px !important;
  }

  .carousel-indicators .active {
    background-image: url('/assets/slider/pointer-active.png') !important;
  }

  .carousel-caption {
    top: 25px !important;
    width: 100%;
    height: auto;
    right: unset !important;
    left: 7px !important;
    background-color: transparent !important;
    text-align: unset !important;
    padding: 15px;
  }

  .carousel-caption h3 {
    font-size: 13pt !important;
  }

  .carousel-caption h2 {
    font-size: 21pt !important;
  }

  .btn-default.slider {
    height: 43px;
    width: 21%;
    display: block;
  }

  .carousel-caption span {
    margin-top: 9px;
    color: #cfcbc0;
    font-size: 9pt;
    display: inline-block;
    width: 45ch;
    word-wrap: break-word;
  }
`;

const StyledImg = styled.img.attrs({className: 'd-block w-100'})`
  max-height: 350px;
`;

const NewsCarousel = () => {
  return (
    <StyledCarousel indicators={true} controls={false} interval={3000}>
      {slides.map((slide, index) => (
        <Carousel.Item key={index}>
          <StyledImg src={slide.img} alt={`Slide ${index + 1}`} />
          <Carousel.Caption className="d-none d-md-block">
            <h3>{slide.title}</h3>
            <h2>{slide.subtitle}</h2>
            <h3>{slide.date}</h3>
            <span>{slide.description}</span>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </StyledCarousel>
  );
};

export default NewsCarousel;
